<div class="modal fade" bsModal #recordsModal="bs-modal" [config]="{backdrop: 'static'}"
     tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-sm">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title pull-xs-left">{{title}}</h4>
                <button type="button" class="close float-sm-right" aria-label="Close" (click)="closeModal()">
                    <span aria-hidden="true"><img src="assets/img/icon-close-reversed.png"></span>
                </button>
            </div>
            <div class="modal-body">                        
                <div class="row" style="margin:0px" >
                    <div>
                        Select a Literal Order Category:
                        <span class="modal-sub-header" style="margin-left: 10px;">
                            <a (click)="selectAllLiteralCategories()">Select All</a></span>
                    </div>
                    <div>
                        <input type="search" [(ngModel)]="searchText" (ngModelChange)="searchLiteralCategories($event)" placeholder="Search" style="width: 330px; margin-bottom: 10px">
                    </div>
                    <div class="invoice-group-content-area">                          

                        <div class="col-12" *ngIf="isLoadingLiteralCategory">
                            <img src="assets/img/loading.gif" height="96" width="96"><br>
                        </div>                      
                        <div *ngFor="let literalCategory of filteredLiteralCategory">
                                
                            <label [class]="areAllCategorySelected ? 'checkbox-square' : 'checkbox'">
                                <input type="checkbox" 
                                        name="literalCategory"
                                        [(ngModel)]="literalCategory.IsSelected"
                                        (change)="selectLiteralCategory($event,literalCategory)"                                       
                                        [value]="literalCategory"><span></span>
                                        <span  class="checkbox-label">
                                            {{literalCategory.Description}}
                                        </span>                                  
                            </label>
                        </div>
                    </div>
                </div>                        
            </div>
            <div class="modal-footer">
                <div class="float-left text-align-left">
                    <button class="btn btn-primary" (click)="closeModal()">Cancel</button>
                </div>
                <div class="float-right text-align-right">
                    <button (click)="generateContent()"
                            [disabled]="!canGenerateReport()"
                            class="btn btn-primary">
                        <img src="assets/img/loading.gif" height="25" width="25" [hidden]="hideSpinner">Download</button>
                </div>
            </div>
        </div>
    </div>
</div>